import { render, staticRenderFns } from "./ModalRfcAlert.vue?vue&type=template&id=3ced0013&"
import script from "./ModalRfcAlert.vue?vue&type=script&lang=js&"
export * from "./ModalRfcAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports